import styled from 'foundations-theming/utils';
export const VisibilityView = styled.div.withConfig({
  displayName: "VisibilityView",
  componentId: "sc-1n27zqh-0"
})(({
  visible = true
}) => {
  return {
    visibility: visible ? 'visible' : 'hidden',
    width: '100%'
  };
});